import angular from 'angular';
import { DraftInvoice } from '../model/draftInvoice';

angular
  .module('cloudX')
  .controller('InvoiceFromScratchCtrl', [
    '$state',
    '$filter',
    'resourceFactorySvc',
    'flySvc',
    'relBindSvc',
    'dialogsSvc',
    'ModalService',
    'dataCache',
    invoiceFromScratchCtrl,
  ]);

function invoiceFromScratchCtrl(
  $state,
  $filter,
  resourceFactorySvc,
  flySvc,
  relBindSvc,
  dialogsSvc,
  ModalService,
  dataCache,
) {
  var vm = this;
  var draftInvoiceResource = resourceFactorySvc.get('draftInvoice');
  vm.companies = dataCache.getArray('company');

  vm.invoiceDateOpen = false;
  vm.invoice = {
    date: new Date(),
    customer: null,
    isInvoice: $state.current.data.isInvoice,
  };

  vm.create = function() {
    if (!vm.invoice.customer || !vm.invoice.customer.id) return;
    vm.saving = true;
    draftInvoiceResource.save(
      { id: 'Post' },
      vm.invoice,
      function(result) {
        vm.saving = false;
        vm.invoice = new DraftInvoice(result);
        vm.invoice.invoiceLines = [];
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.cancel = function() {
    if (!vm.invoice || !vm.invoice.id) return;
    draftInvoiceResource.remove(
      {
        id: vm.invoice.id,
      },
      function() {
        $state.go('invoicing.draft');
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.next = function() {
    if (!vm.invoice || !vm.invoice.id) return;
    $state.go('invoicing.draft', {
      relation: vm.invoice.customer,
    });
  };
  vm.finalize = function(sendMail) {
    if (!vm.invoice || !vm.invoice.id) return;

    const doFinalizeInvoice = () => {
      vm.saving = true;
      resourceFactorySvc.get('invoice').number(
        {
          sendMail: sendMail,
        },
        [vm.invoice.id],
        function(result) {
          vm.saving = false;
          if (result && result.hasOwnProperty(vm.invoice.id)) {
            $state.go('invoicing.draft', {
              relation: vm.invoice.customer,
            });
          } else {
            flySvc.success('msgInvoiceProcessed', {
              name: $filter('relationName')(vm.invoice.customer),
            });
            $state.go('invoicing.overview');
          }
        },
        function(error) {
          vm.saving = false;
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
    };

    if (vm.invoice.totalExclusive > 0 && !vm.invoice.isInvoice) {
      return dialogsSvc
        .showYesNo('comfirmTitle', 'confirmFinalizePositiveCreditNote')
        .then(function() {
          return doFinalizeInvoice();
        });
    }

    if (vm.invoice.totalExclusive < 0 && vm.invoice.isInvoice) {
      return dialogsSvc
        .showYesNo('comfirmTitle', 'confirmFinalizeNegativeInvoice')
        .then(function() {
          return doFinalizeInvoice();
        });
    }

    return doFinalizeInvoice();
  };

  vm.newCustomer = function() {
    dialogsSvc
      .showRelationWizard('newCustomer', {
        crmType: 3,
        crmTypeDisabled: true,
        showKBO: false,
      })
      .then(function(result) {
        if (result && result.relation && result.relation.id) {
          vm.invoice.customer = result.relation;
          vm.customerChanged();
        }
      });
  };

  vm.getErrorMsg = flySvc.getErrorMsg;

  vm.fixErrors = function(invoice) {
    if (invoice.companyErrors.length) {
      $state.go('settings.company');
    } else if (invoice.relationErrors.length) {
      $state.go('relations.detail', {
        relId: invoice.customer.id,
      });
    }
  };
  vm.customerChanged = function() {
    const { customer } = vm.invoice;
    //console.log(customer);
    if (!customer || !customer.id) {
      vm.invoice.invoiceStreamId = null;
      vm.invoiceStreams = [];
    } else {
      vm.invoice.companyId = customer.companyId;
      vm.invoice.invoiceStreamId = customer.invoiceStreamId;
      vm.invoiceStreams = customer.invoiceStreams || [];
      const invoiceStream = vm.invoiceStreams.find(x => x.id == customer.invoiceStreamId);
      if (invoiceStream?.companyId) {
        vm.invoice.companyId = invoiceStream.companyId;
      }
    }
  };
  vm.assignmentChanged = function() {
    if (!vm.invoice.customer) {
      vm.invoice.companyId = null;
      return;
    }
    const invoiceStream = (vm.invoiceStreams || []).find(x => x.id == vm.invoice.invoiceStreamId);
    if (invoiceStream?.companyId) {
      vm.invoice.companyId = invoiceStream.companyId;
    } else {
      vm.invoice.companyId = vm.invoice.customer?.companyId;
    }
  };

  vm.changeIsInvoice = function(invoice) {
    const isInvoice = !invoice.isInvoice;
    vm.updateInvoice(isInvoice, 'isInvoice');
  };

  vm.updateInvoice = function(value, property) {
    if (value === undefined || vm.invoice[property] === value) return false;

    vm.invoice[property] = value;
    var model = angular.copy(vm.invoice);

    return draftInvoiceResource.update(model).$promise.then(
      function(data) {
        delete data.invoiceLines;
        angular.extend(vm.invoice, data);
        return false;
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    );
  };
}
